<template>
  <component
    :is="disabled ? 'span' : 'router-link'"
    :to="{ name: 'CabinetMaster' }"
    class="lockup"
    :class="logoStyle"
    :style="{ '--lockup-logo-h': height + 'px' }"
  >
    <img class="lockup-mark" :src="logoAsset" alt="Lisse" />
    <span class="lockup-service" v-if="serviceName">{{ serviceName }}</span>
  </component>
</template>

<script>
export default {
  name: 'Logo',
  props: {
    logoStyle: {
      type: String,
      required: true
    },
    logoAsset: {
      type: String,
      required: true
    },
    // サービス名はロゴ画像に焼き込まない。焼き込みの確定形 SVG があるのは
    // 契約書レビューのみで、契約書管理はテキストで仮当てする
    // （テキスト入りロックアップ完成後に差し替える）
    serviceName: {
      type: String,
      required: false,
      default: ''
    },
    // ロゴマークの高さ。サービス名とギャップはこの値から比率で決まる
    height: {
      type: Number,
      required: false,
      default: 28
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.auth.isLoggedIn;
    }
  }
};
</script>

<style scoped>
/*
ロックアップ確定仕様（2026-08-27 決定 / Design Hub「プロダクトロゴとロックアップ」）
  区切り線なし・ギャップのみで分離（ロゴ高の約 42%）
  サービス名 = ロゴ高の 46% / Noto Sans JP / 700
  明るい背景のテキストは #26241F、濃色背景は白 → 帯の色を継承させる
*/
.lockup {
  display: inline-flex;
  align-items: center;
  gap: calc(var(--lockup-logo-h) * 0.42);
  text-decoration: none;
  color: inherit;
}

.lockup-mark {
  display: block;
  height: var(--lockup-logo-h);
  width: auto;
  /* 公式アセットの縦横比。読み込み前のガタつきを防ぐ */
  aspect-ratio: 201 / 63;
  flex: none;
}

.lockup-service {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: calc(var(--lockup-logo-h) * 0.46);
  font-weight: 700;
  letter-spacing: 0.03em;
  line-height: 1;
  white-space: nowrap;
}

/* OEM ブランドはリブランド対象外。従来どおり画像の固定サイズで出す */
.logo-cloudsign .lockup-mark {
  height: 15px;
  width: 204px;
  aspect-ratio: auto;
}
.logo-moneyforward .lockup-mark {
  height: 60px;
  width: 290px;
  aspect-ratio: auto;
}
</style>
